export const tokens = {
  'theme-1': '#0067B9',
  'theme-2': '#6D6E6E',
  'theme-3': '#C22C91',
  'theme-4': '#EDEDED',
  'theme-5': '#2581C4',
  'theme-6': '#CB3F8F',
  'theme-7': '#C30D31',
  'theme-8': '#A6192E',
  'theme-9': '#D6D2C4',
  'theme-10': '#949494',
  'theme-11': '#115E67',
  'theme-12': '#7CABDC',
  'theme-13': '#00A1AF',
  'theme-14': '#EE4028',
  'theme-15': '#F7A823',
  'theme-16': '#007CBA',
  'theme-17': '#17808E',
  'theme-18': '#DADADA',
  'theme-19': '#BFC3C6',
  'theme-20': '#291B41',
  'theme-21': '#14354B',
  'theme-22': '#4D3F7F',
  'theme-23': '#6E2B62',
  'theme-24': '#9D9D9D',
  'theme-25': '#C8D9F1',
  'theme-26': '#ffffff',
  'theme-27': '#00909A'
};